<template>
  <div class="vertical-layout">
    <b-row class="principal mt-2">
      <b-col md="12">
        <b-card-title
          class="font-medium-2"
          style="text-align: center;"
        >
          <span>Términos y condiciones</span>
        </b-card-title>
      </b-col>
<!--      <div class="page-next mb-2 d-flex align-items-center justify-content-center">-->
      <b-col md="12">
        <b-card-title
          class="font-medium-2"
          style="text-align: center;"
        >
          <nav
            aria-label="breadcrumb"
            class="d-inline-block"
            style="text-align: center;"
          >
            <ul class="breadcrumb bg-white rounded shadow mb-0">
              <li class="breadcrumb-item">
                <a href="">Lobitozz</a>
              </li>
              <li
                class="breadcrumb-item active"
                aria-current="page"
              >
                Términos y condiciones
              </li>
            </ul>
          </nav>
        </b-card-title>
      </b-col>
<!--      </div>-->
      <body>
        <section class="section">
          <div>
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div class="card shadow border-0 rounded">
                  <div class="card-body">
                    <h5 class="card-title">
                      INTRODUCCIÓN :
                    </h5>
                    <p class="text-muted text-justify">
                      Las presentes condiciones de uso de la plataforma web, regulan los términos de acceso y uso de Lobitozz, propiedad de Lobitozz, en adelante, “la Empresa”, que el usuario de la plataforma web deberá aceptar para usar todos los servicios e información que se facilitan desde la plataforma web.
                    </p>
                    <p class="text-muted text-justify">
                      El usuario así como la Empresa, propietaria de la plataforma web, podrán ser denominados conjuntamente como "Las partes". El mero acceso o utilización de la plataforma web, de todos o parte de sus contenidos y servicios significa la plena aceptación de las presentes condiciones de uso. La puesta a disposición y el uso de la plataforma web se entiende sometida al estricto cumplimiento de los términos recogidos en las presentes condiciones de uso de la plataforma web.
                    </p>

                    <h5 class="card-title">
                      ANTECENDENTES :
                    </h5>
                    <p class="text-muted text-justify">
                      La empresa está domiciliada en la ciudad de Guayaquil. Es titular dominio de la aplicación "COMEXTWEB", y propietaria exclusiva de la información contenida en el mismo. La plataforma permite realizar compras en línea de planes mensuales mediante el una tienda virtual que se encuentra en la página web. La creación y acceso a cuentas privadas para el registro, administración y almacenamiento de la información de la cuenta. El usuario, podrá utilizar la "Plataforma web" con el objetivo de adquirir los planes que se encuentra en la plataforma.
                    </p>

                    <h5 class="card-title">
                      INFORMACIÓN Y SERVICIOS :
                    </h5>
                    <p class="text-muted text-justify">
                      Los usuarios pueden acceder a través de la plataforma web a diferente tipo de información y servicios. La plataforma web  se reserva la facultad de modificar, en cualquier momento, y sin aviso previo, la presentación y configuración de la información y servicios ofrecidos desde la plataforma web. El usuario reconoce y acepta expresamente que en cualquier momento La plataforma web pueda interrumpir, desactivar y/o cancelar cualquier información o servicio. La plataforma web realizará sus mejores esfuerzos para intentar garantizar la disponibilidad y accesibilidad a la web. No obstante, en ocasiones, por razones de mantenimiento, actualización, cambio de ubicación, etc., podrá suponer la interrupción del acceso a la plataforma web.
                    </p>

                    <h5 class="card-title">
                      RESPONSABILIDAD SOBRE LOS CONTENIDOS :
                    </h5>
                    <p class="text-muted text-justify">
                      La aplicación no interviene en la creación de aquellos contenidos y/o servicios prestados o suministrados por terceras partes en y/o a través de la aplicación, del mismo modo que tampoco controla su licitud. En cualquier caso, no ofrece ninguna clase de garantía sobre los mismos. El usuario reconoce que la aplicación no es ni será responsable de los contenidos y/o servicios prestados o suministrados por terceras partes en y/o a través de la aplicación. El usuario acepta que la aplicación no asumirá responsabilidad alguna por cualquier daño o perjuicio producido como consecuencia de la utilización de esta información o servicios de terceros.
                    </p>
                    <p class="text-muted text-justify">
                      Exceptuando los casos que la Ley imponga expresamente lo contrario, y exclusivamente con la medida y extensión en que lo imponga, la aplicación no garantiza ni asume responsabilidad alguna respecto a los posibles daños y perjuicios causados por el uso y utilización de la información, datos y servicios de la aplicación. En todo caso, la aplicación excluye cualquier responsabilidad por los daños y perjuicios que puedan deberse a la información y/o servicios prestados o suministrados por terceros diferentes de la Empresa. Toda responsabilidad será del tercero ya sea proveedor, colaborador u otro.
                    </p>

                    <h5 class="card-title">
                      OBLIGACIONES DEL USUARIO :
                    </h5>
                    <p class="text-muted text-justify">
                      El usuario deberá respetar en todo momento los términos y condiciones establecidos en el presente aviso legal. De forma expresa, el usuario manifiesta que utilizará La plataforma web de forma diligente y asumiendo cualquier responsabilidad que pudiera derivarse del incumplimiento de las normas. El usuario se obliga, en aquellos casos que se le soliciten datos o información, a no falsear su identidad haciéndose pasar por cualquier otra persona. El usuario acepta que la utilización de la plataforma web será efectuada con fines estrictamente personales, privados y particulares. El usuario no podrá utilizar La plataforma web para actividades contrarias a la Ley, la moral y el orden público así como para finalidades prohibidas o que vulneren o lesionen derechos de terceros.
                    </p>
                    <p class="text-muted text-justify">
                      Asimismo, queda prohibida la difusión, almacenamiento y/o gestión de datos o contenidos que infrinjan derechos de terceros o cualesquiera normativas reguladoras de derechos de propiedad intelectual o industrial. Así mismo, el usuario no podrá utilizar La plataforma web para transmitir, almacenar, divulgar promover o distribuir datos o contenidos que sean portadores de virus o cualquier otro código informático, archivos o programas diseñados para interrumpir, destruir o perjudicar el funcionamiento de cualquier programa o equipo informático o de telecomunicaciones.
                    </p>
                    <p class="text-muted text-justify">
                      El usuario se obliga a indemnizar y a mantener indemnes a la plataforma web por cualquier daño, perjuicio, sanción, multa, pena o indemnización que tenga que hacer frente La plataforma.
                    </p>

                    <h5 class="card-title">
                      CUMPLIMIENTO LOPD (Ley de protección de datos de carácter personal) :
                    </h5>
                    <p class="text-muted text-justify">
                      La plataforma web adopta para el tratamiento de los datos todas las medidas técnicas y organizativas de seguridad que sean de obligación, de conformidad con lo establecido por la legislación vigente.
                    </p>
                    <p class="text-muted text-justify">
                      El usuario manifiesta de forma expresa que cualquier dato personal o de un tercero al que acceda, introduzca, modifique o suprima tiene derecho a hacerlo o dispone de la autorización expresa de este tercero. La plataforma web informa al usuario que podrá ejercer los derechos de acceso, rectificación, oposición y cancelación dirigiéndose a la siguiente dirección: Av. Francisco de Orellana, Edificio World Trade Center, Piso 5, Oficina 509, Guayaquil, Guayas, Ecuador
                    </p>
                  </div>
                </div>
              </div><!--end col-->
            </div><!--end row-->
          </div><!--end container-->
        </section><!--end section-->
      </body>
      <!-- Footer -->
      <footer
        class="footer footer-light"
        :class="[footerTypeClass]"
      >
        <slot name="footer">
          <app-footer />
        </slot>
      </footer>
      <slot name="customizer" />
    <!-- /Footer -->
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCardTitle,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import AppFooter from '@core/layouts/components/AppFooter.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import useVerticalLayout from '@core/layouts/layout-vertical/useVerticalLayout'
import { onUnmounted } from '@vue/composition-api/dist/vue-composition-api'

export default {
  components: {
    BRow,
    BCol,
    BCardTitle,
    BCardCode,
    AppFooter,
  },
  setup() {
    const { navbarType, footerType } = useAppConfig()

    const {
      resizeHandler,
      footerTypeClass,
    } = useVerticalLayout(navbarType, footerType)

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      footerTypeClass,
    }
  },
}

</script>

<style>
.principal .card-header{
    display: none !important
}
.principal .card-body{
    padding-bottom: 0 !important;
}
</style>
